<div class="not-found-container">
	<span
		class="icon"
		[ngClass]="{ start: bloobStarted, finish: bloobColddown }"
		[ngStyle]="{ 'font-size': bloobSize + 'px' }"
		(click)="bloob()"
		><fa-icon [icon]="icons.faRobot"></fa-icon
	></span>
	<div class="message">
		<span>{{ labels.lbl_geral_eita }}!</span>
		<span>{{ labels.lbl_nao_conseguimos_acessar_rota }}</span>
	</div>

	<div class="button-container">
		<div class="button" (click)="backToHome()">{{ labels.lbl_geral_voltar_para_seguranca }}</div>
		@if (AuthLoginService.isLoggedIn()) {
			<div class="button" (click)="logoff()">{{ labels.lbl_geral_desconectar }}</div>
		}
	</div>
</div>
